import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ImplementacionService } from '../../../../../shared/services/implementacion.service';
import { VersionesDocumentoService } from '../../../../../shared/services/versiones-documento.service';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-listado-retencion',
  templateUrl: './listado-retencion.component.html',
  styleUrls: ['./listado-retencion.component.scss']
})
export class ListadoRetencionComponent implements OnInit {

 documentos: any[] = [];
  documentosFiltrados: any[] = [];
  cargando = false;
  searchText = '';

  // Paginación
  pageSize: number = 10;
  page: number = 1;

  // Ordenamiento
  sortColumn: string = '';
  sortDirection: string = 'asc';

  constructor(
    private router: Router,
    private implementacionService: ImplementacionService,
    private versionesDocumentoService: VersionesDocumentoService
  ) {}

  ngOnInit(): void {
    this.cargarDocumentos();
  }


  cargarDocumentos(): void {
    this.implementacionService.getAllImplementaciones().subscribe({
      next: (response) => {
        this.documentos = response;
        this.documentosFiltrados = [...this.documentos];
        this.cargando = false;
      },
      error: (err: any) => {
        console.error('Error al cargar documentos:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los documentos',
          confirmButtonText: 'Aceptar'
        });
        this.cargando = false;
      }
    });
  }

  claseBadgeEstado(estadoId: any): string {
    switch (Number(estadoId)) {
      case 2:
        return 'badge-light-warning';
      case 3:
        return 'badge-light-success';
      case 4:
      case 5:
      case 6:
        return 'badge-light-danger';
      case 1:
      default:
        return 'badge-light-secondary';
    }
  }

  filtrarDocumentos(): void {
    const search = this.searchText.toLowerCase().trim();
    if (!search) {
      this.documentosFiltrados = [...this.documentos];
      return;
    }

    this.documentosFiltrados = this.documentos.filter(doc =>
      doc.codigo?.toLowerCase().includes(search) ||
      doc.nombre?.toLowerCase().includes(search) ||
      doc.tipo_documental?.nombre?.toLowerCase().includes(search) ||
      doc.pilar?.nombre?.toLowerCase().includes(search) ||
      doc.EstadoDocumentosImplementacion?.nombre?.toLowerCase().includes(search)
    );
  }

  sortData(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.documentosFiltrados.sort((a, b) => {
      const aValue = this.getNestedValue(a, column);
      const bValue = this.getNestedValue(b, column);

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      return this.sortDirection === 'asc' ? comparison : -comparison;
    });
  }

  private getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((current, prop) => current?.[prop], obj);
  }

  nuevoDocumento(): void {
    this.router.navigate(['/registrar-retencion']);
  }

  editarDocumento(documento: any): void {
    this.router.navigate(['/editar-retencion', documento.id]);
  }

  descargarDocumento(documento: any): void {
    this.versionesDocumentoService.getVersionVigente(documento.id).subscribe({
      next: (version) => {
        if (version?.archivo) {
          this.implementacionService.descargarUrl(version.archivo).subscribe({
            next: () => Swal.fire({
              icon: 'success',
              title: 'Descarga iniciada',
              text: 'El documento se descargará en el dispositivo.',
              confirmButtonText: 'Aceptar'
            }),
            error: (err: any) => {
              console.error('Error al descargar:', err);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo descargar el documento',
                confirmButtonText: 'Aceptar'
              });
            }
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Sin archivo',
            text: 'El documento no tiene una versión vigente disponible',
            confirmButtonText: 'Aceptar'
          });
        }
      },
      error: (err) => {
        console.error('Error al descargar:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo descargar el documento',
          confirmButtonText: 'Aceptar'
        });
      }
    });
  }

  puedeInactivar(documento: any): boolean {
    return documento?.EstadoDocumentosImplementacion?.id === 3;
  }

  puedeActivar(documento: any): boolean {
    return documento?.EstadoDocumentosImplementacion?.id === 1;
  }

  puedeCambiarEstado(documento: any): boolean {
    return this.puedeInactivar(documento) || this.puedeActivar(documento);
  }

  cambiarEstadoDocumento(documento: any, nuevoEstado: boolean): void {
    const accion = nuevoEstado ? 'activar' : 'inactivar';

    if (nuevoEstado ? !this.puedeActivar(documento) : !this.puedeInactivar(documento)) {
      Swal.fire({
        icon: 'warning',
        title: 'Acción no permitida',
        text: nuevoEstado
          ? 'Solo se puede activar un documento en estado BORRADOR'
          : 'Solo se puede inactivar un documento en estado VIGENTE',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    Swal.fire({
      title: '¿Estás seguro?',
      text: `¿Deseas ${accion} el documento "${documento.nombre}"?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    }).then((result: any) => {
      if (result.isConfirmed) {
        const solicitud = nuevoEstado
          ? this.implementacionService.activateImplementacion(documento.id)
          : this.implementacionService.inactivateImplementacion(documento.id);

        solicitud.subscribe({
          next: () => {
            documento.activo = nuevoEstado;
            this.cargarDocumentos();
            Swal.fire({
              icon: 'success',
              title: 'Éxito',
              text: `Documento ${accion === 'activar' ? 'activado' : 'inactivado'} correctamente`,
              confirmButtonText: 'Aceptar'
            });
          },
          error: (err: any) => {
            console.error('Error al cambiar estado:', err);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se pudo cambiar el estado del documento',
              confirmButtonText: 'Aceptar'
            });
          }
        });
      }
    });
  }

  exportarExcel(): void {
    const datosExportar = this.documentosFiltrados.map(doc => ({
      'Código': doc.codigo,
      'Nombre': doc.nombre,
      'Tipo Documental': doc.tipo_documental?.nombre || '-',
      'Pilar': doc.pilar?.nombre || '-',
      'Estado': doc.estado?.nombre || '-',
      'Retención (años)': doc.retencion || '-',
      'Fecha Creación': new Date(doc.fecha_creacion).toLocaleDateString('es-ES'),
      'Activo': doc.activo ? 'Sí' : 'No'
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(datosExportar);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Documentos PESV');

    const fecha = new Date().toISOString().split('T')[0];
    XLSX.writeFile(wb, `Documentos_PESV_${fecha}.xlsx`);

    Swal.fire({
      icon: 'success',
      title: 'Exportado',
      text: 'El archivo Excel se ha descargado correctamente',
      confirmButtonText: 'Aceptar',
      timer: 2000
    });
  }

  exportarPDF(): void {
    const doc = new jsPDF('l', 'mm', 'a4');
    
    // Título
    doc.setFontSize(16);
    doc.text('LISTADO DE DOCUMENTOS MAESTROS PESV', doc.internal.pageSize.getWidth() / 2, 15, { align: 'center' });
    
    // Fecha
    doc.setFontSize(10);
    doc.text(`Fecha: ${new Date().toLocaleDateString('es-ES')}`, 14, 25);

    // Preparar datos
    const datosTabla = this.documentosFiltrados.map(doc => [
      doc.codigo,
      doc.nombre,
      doc.tipo_documental?.nombre || '-',
      doc.pilar?.nombre || '-',
      doc.estado?.nombre || '-',
      doc.retencion || '-',
      new Date(doc.fecha_creacion).toLocaleDateString('es-ES'),
      doc.activo ? 'Sí' : 'No'
    ]);

    // Generar tabla
    autoTable(doc, {
      head: [['Código', 'Nombre', 'Tipo Documental', 'Pilar', 'Estado', 'Retención', 'Fecha', 'Activo']],
      body: datosTabla,
      startY: 30,
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [115, 102, 255], textColor: 255 },
      alternateRowStyles: { fillColor: [245, 245, 245] }
    });

    const fecha = new Date().toISOString().split('T')[0];
    doc.save(`Documentos_PESV_${fecha}.pdf`);

    Swal.fire({
      icon: 'success',
      title: 'Exportado',
      text: 'El archivo PDF se ha descargado correctamente',
      confirmButtonText: 'Aceptar',
      timer: 2000
    });
  }
}